import React, { FunctionComponent } from 'react';

export const PiggyBankIcon: FunctionComponent = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 49 48">
      <g clip-path="url(#a)">
        <path fill="#D09BFD" d="M17.166 7.5a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z" />
        <path
          fill="#D09BFD"
          d="M13.166 13.512a16.636 16.636 0 0 0-6.8 8.9h-3.7v12h4.98a16.934 16.934 0 0 0 4.02 4.744v5.756a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5V42.43a19.024 19.024 0 0 0 12 .022v2.46a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5v-5.726a15.882 15.882 0 0 0 6-12.274A16.106 16.106 0 0 0 34.154 13.5"
        />
        <path
          stroke="#252B33"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M47.166 21a6 6 0 0 1-6 6M12.666 13.6a16.636 16.636 0 0 0-6.8 8.9h-3.7v12h4.98a16.935 16.935 0 0 0 4.02 4.744V45a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5v-2.482a19.024 19.024 0 0 0 12 .022V45a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5v-5.726a15.882 15.882 0 0 0 6-12.274 16.106 16.106 0 0 0-7.513-13.412"
        />
        <path
          stroke="#252B33"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M17.166 15a13.526 13.526 0 0 1 12 0"
        />
        <path
          stroke="#252B33"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M17.166 7.5a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M.667 0h48v48h-48z" />
        </clipPath>
      </defs>
    </svg>
  );
};
